var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-button empty-button-get",class:{
    'empty-button-get-active' : _vm.isClick
  },on:{"click":_vm.buttonClick}},[_c('div',{staticClass:"empty-button-txt position-center",domProps:{"textContent":_vm._s(_vm.$t('global.moreGame'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }